module.exports = __webpack_public_path__ + "static/media/holdSpacebar.44b8b9bc.webm";